<template>
    <span
      class="pointer"
      :style="{
            opacity: (loading)?0.5:1,
            'border-radius': '10%',
          }"
      @click="onChange"
    >
      <hoover v-if="hooverModeEnable()"
        :fill="isOk?'red':'#000000'"
        class="ma-1"
        style="vertical-align: sub"
        :size="size"/>
    </span>
</template>

<script>
/* components */
import hoover from '../icons/hoover.vue';

import settingsMixin from '@/mixins/settingsMixin';

export default {
  name: 'IsHoover',
  mixins: [
      settingsMixin,
  ],
  props: {
    isOk: {
      type: Number,
      default: 0,
    },
    icon: {
      type: String,
      default: 'mdi-account',
    },
    updateRequest: {
      type: Function,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: '24px',
    },
  },
  components: {
    hoover,
  },
  data() {
    return {
    };
  },
  methods: {
    onChange() {
      if (!hooverModeEnable()) {
        return;
      }
      if (!this.loading) {
        this.updateValue(1 - this.isOk);
      }
    },
    updateValue(value) {
      this.$emit('updated', value);
      if (this.updateRequest) {
        this.loading = true;
        setTimeout(() => {
          this.updateRequest(value)
            .catch(error => {
              this.$emit('updated', 1 - value);
              console.error(error);
            })
            .finally(() => {
              this.loading = false;
            });
        }, 0);
      }
    },
  },
};
</script>

<style scoped>

</style>
